import { render, staticRenderFns } from "./AnamnesisDetails.vue?vue&type=template&id=240be46d&scoped=true"
import script from "./AnamnesisDetails.vue?vue&type=script&lang=js"
export * from "./AnamnesisDetails.vue?vue&type=script&lang=js"
import style0 from "./AnamnesisDetails.vue?vue&type=style&index=0&id=240be46d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240be46d",
  null
  
)

export default component.exports